import React, { useState, useEffect } from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import api from '../config/api';

const HEALTH_CHECK_INTERVAL_MS = 60000; // 1 min

const HealthStatusBanner = () => {
  const { t } = useTranslation();
  const [status, setStatus] = useState(null); // null = loading, 'ok' | 'degraded' | 'down'

  useEffect(() => {
    const check = async () => {
      try {
        const res = await api.get('/health', { timeout: 8000 });
        const data = res.data;
        if (data.database === 'down') {
          setStatus('degraded');
        } else {
          setStatus('ok');
        }
      } catch (err) {
        setStatus('down');
      }
    };

    check();
    const id = setInterval(check, HEALTH_CHECK_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);

  if (status === null || status === 'ok') return null;

  return (
    <Box sx={{ py: 1, px: { xs: 1, sm: 2 } }}>
      <Alert
        severity={status === 'down' ? 'error' : 'warning'}
        sx={{ borderRadius: 2 }}
      >
        <AlertTitle>
          {status === 'down' ? t('health.serviceUnavailable') : t('health.databaseUnavailable')}
        </AlertTitle>
        {status === 'down'
          ? t('health.serviceUnavailableDesc')
          : t('health.databaseUnavailableDesc')}
      </Alert>
    </Box>
  );
};

export default HealthStatusBanner;
